var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconBlu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/edit-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9743 3.00002L5.13261 10.2417C4.87427 10.5167 4.62427 11.0584 4.57427 11.4334L4.26594 14.1334C4.15761 15.1084 4.85761 15.775 5.82427 15.6084L8.50761 15.15C8.88261 15.0834 9.40761 14.8084 9.66594 14.525L16.5076 7.28335C17.6909 6.03335 18.2243 4.60835 16.3826 2.86668C14.5493 1.14168 13.1576 1.75002 11.9743 3.00002Z",
    stroke: "#3282C4",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.832 4.20801C11.1904 6.50801 13.057 8.26634 15.3737 8.49967",
    stroke: "#3282C4",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.42383 18.333H18.4238",
    stroke: "#3282C4",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBlu);
export default __webpack_public_path__ + "static/media/edit-icon-blu.31076059bddcdab12ed5b7af6268ab85.svg";
export { ForwardRef as ReactComponent };